module.exports = require("natural-compare-lite");


//////////////////
// WEBPACK FOOTER
// external "natural-compare-lite"
// module id = 14
// module chunks = 0